import { ApplicationMessageSource } from './../../../core/models/application-message-source';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessage } from './../../../core/models/application-message';
import { CustomMessageService } from './../../../core/message.service';
import { InvoiceActionResultType } from '../shared/models/invoice-action-result-type';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { InvoiceListItemModel } from '../shared/models/invoice-list-item-model';
import { InvoiceStatus } from '../shared/models/invoice-status';
import { InvoiceListFilterModel } from '../shared/models/invoice-list-filter-model';
import { InvoiceService } from '../shared/services/invoice.service';
import { LookupService } from '../../../shared/services/lookup.service';
import { PortfolioAccountManagerAdminModel } from '@admin/portfolios/shared/models/portfolio-account-manager-admin-model';
import { PortfolioService } from '@admin/portfolios/shared/services/portfolio.service';
import { ConfigurationService } from '@admin/shared/services/configuration.service';
import { FeatureEnum } from '@admin/shared/models/feature-enum';
import { UserService } from '../../../core/user.service';
import { InvoiceAccountingStatus } from '@admin/billing/invoices/shared/models/invoice-accounting-status';
import { InvoiceType } from '@admin/billing/invoices/shared/models/invoice-type';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.less'],
  standalone: false,
})
export class InvoiceListComponent implements OnInit {
  public filterPagingWrapper: PagingFilter<InvoiceListFilterModel>;

  public invoices: InvoiceListItemModel[];
  public selectedInvoices: InvoiceListItemModel[];

  public hasViewAllInvoicesPermission: boolean;
  public hasInvoiceMergeUnmergePermission: boolean;
  public hasEditInvoicePermission: boolean;
  public hasEditInvoiceAccountingPermission: boolean;
  public hasInvoiceApprovePermission: boolean;

  public totalRecords: number;
  public pageSize: number;
  public dateFormat: string;
  public specialDateFormat: string;

  public invoicesTotal: number;
  public mismatchesCount: number;

  public accountManagers: PortfolioAccountManagerAdminModel[];
  public invoiceStatuses: SelectItem[];
  public invoiceAccountingStatuses: SelectItem[];

  public InvoiceType = InvoiceType;

  public trySendInvoice: boolean;

  private defaultDayCountFilter = 2;

  constructor(
    private lookupService: LookupService,
    private invoiceService: InvoiceService,
    private portfolioService: PortfolioService,
    private route: ActivatedRoute,
    private config: ConfigurationService,
    private translateService: TranslateService,
    private messageService: CustomMessageService,
    private userService: UserService
  ) {
    this.filterPagingWrapper = new PagingFilter(
      new InvoiceListFilterModel(this.defaultDayCountFilter)
    );
    this.invoices = [];
    this.selectedInvoices = [];
    this.accountManagers = [];
    this.hasViewAllInvoicesPermission = false;
    this.invoicesTotal = 0;
    this.trySendInvoice = false;
  }

  onLoad(event: LazyLoadEvent) {
    if (event.sortField && event.sortOrder) {
      this.filterPagingWrapper.sortParameters = [
        {
          column: event.sortField,
          order: event.sortOrder == 1 ? 'asc' : 'desc',
        },
      ];
    }
    this.filterPagingWrapper.pagingInfo.start = event.first;
    this.filterPagingWrapper.pagingInfo.limit = event.rows;
    this.onFilter();
  }

  onFilter() {
    this.selectedInvoices = [];
    this.filterPagingWrapper.pagingInfo.start =
      this.filterPagingWrapper.pagingInfo.start || 0;
    this.invoiceService
      .listInvoices(this.filterPagingWrapper)
      .subscribe((i) => {
        this.totalRecords = i.totalCount;
        this.invoices = i.items;

        this.loadTotals();
      });
  }

  private loadTotals() {
    this.invoiceService
      .getInvoicesTotalAmount(this.filterPagingWrapper)
      .subscribe((t) => {
        this.invoicesTotal = t.invoicesTotal;
        this.mismatchesCount = t.mismatchedInvoicesCount;
      });
  }

  onClearFilter() {
    this.filterPagingWrapper = new PagingFilter(
      new InvoiceListFilterModel(null)
    );
  }

  onApplyFilter() {
    this.filterPagingWrapper.pagingInfo.start = 0;

    this.onFilter();
  }

  getSpecialDateFormat(format: string) {
    return format.replace('MM', 'mm').replace('yyyy', 'yy');
  }

  getRowStyleClass(invoice: InvoiceListItemModel) {
    return invoice.statusId == InvoiceStatus.Canceled
      ? 'canceled-invoice'
      : invoice.isEdited
      ? 'edited-invoice'
      : '';
  }

  public onInvoiceMerge() {
    if (this.selectedInvoices.length <= 1) return;

    if (
      this.selectedInvoices.filter(
        (i) => i.invoiceTypeId == InvoiceType.DebitCorrection
      ).length > 0
    ) {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: MessageType.Error,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: this.translateService.instant(
          'message.NotAllowedOperationOnOldDebtInvoice'
        ),
      });
      return;
    }

    let ans = confirm(this.translateService.instant('message.AreYouSure'));
    if (!ans) {
      return;
    }

    this.invoiceService.mergeInvoice(this.selectedInvoices).subscribe((d) => {
      if (d.resultType == InvoiceActionResultType.Success) {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Success,
          sourceId: ApplicationMessageSource.global,
          summary: '',
          detail: d.displayMessage,
        });
        this.selectedInvoices = [];
      }
      // else if(d.resultType == InvoiceActionResultType.PartialSuccess){
      //   this.messageService.pushMessage(<ApplicationMessage>{
      //     type: MessageType.Warning,
      //     sourceId: ApplicationMessageSource.global,
      //     summary: '',
      //     detail: d.displayMessage
      //   });
      //   this.selectedInvoices = this.invoices.filter(t => d.errorMessages[t.invoiceId] != null);

      // }
      else if (d.resultType == InvoiceActionResultType.Failure) {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Error,
          sourceId: ApplicationMessageSource.global,
          summary: '',
          detail: d.displayMessage,
        });
        this.selectedInvoices = this.invoices.filter(
          (t) => d.errorMessages[t.invoiceId] != null
        );
      } else {
        throw Error('invalid data');
      }

      this.refresh();
    });
  }

  public onInvoiceUnmerge() {
    if (this.selectedInvoices.length != 1) {
      alert(
        this.translateService.instant('message.SelectOnlyOneInvoiceForUnmerge')
      );
      return;
    }

    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }

    this.invoiceService
      .unmergeInvoice(this.selectedInvoices[0])
      .subscribe((d) => {
        if (d.resultType == InvoiceActionResultType.Success) {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Success,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: d.displayMessage,
          });
          this.selectedInvoices = [];
        } else if (d.resultType == InvoiceActionResultType.Failure) {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Error,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: d.displayMessage,
          });
          this.selectedInvoices = this.invoices.filter(
            (t) => d.errorMessages[t.invoiceId] != null
          );
        } else {
          throw Error('invalid data');
        }

        this.refresh();
      });
  }

  private refresh() {
    this.onFilter();
  }

updateInvoiceDate(invoice: InvoiceListItemModel, $event: string) {
  if (confirm(this.translateService.instant('message.AreYouSure'))) {

    let dateToSend: Date;

    const [year, month, day] = $event.split('-').map(Number);
    dateToSend = new Date(year, month - 1, day);

    this.invoiceService
      .updateInvoiceActivationDate(invoice.invoiceId, dateToSend)
      .subscribe(() => {});
  }
  
  this.refresh();
}

  onAccountingStatusChange(invoice: InvoiceListItemModel, $event: any) {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      this.invoiceService
        .updateInvoiceAccountingStatus(invoice.invoiceId, $event)
        .subscribe(() => {
          this.refresh();
        });
    }
  }

  onInvoiceApprove() {
    let ans = confirm(this.translateService.instant('message.AreYouSure'));
    if (!ans) {
      return;
    }

    this.invoiceService.approveInvoice(this.selectedInvoices).subscribe((d) => {
      if (d.resultType == InvoiceActionResultType.Success) {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Success,
          sourceId: ApplicationMessageSource.global,
          summary: '',
          detail: d.displayMessage,
        });
        this.selectedInvoices = [];
      } else if (d.resultType == InvoiceActionResultType.PartialSuccess) {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Warning,
          sourceId: ApplicationMessageSource.global,
          summary: '',
          detail: d.displayMessage,
        });
        this.selectedInvoices = this.invoices.filter(
          (t) => d.errorMessages[t.invoiceId] != null
        );
      } else if (d.resultType == InvoiceActionResultType.Failure) {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Error,
          sourceId: ApplicationMessageSource.global,
          summary: '',
          detail: d.displayMessage,
        });
        this.selectedInvoices = this.invoices.filter(
          (t) => d.errorMessages[t.invoiceId] != null
        );
      } else {
        throw Error('invalid data');
      }

      this.refresh();
    });
  }

  onSendInvoiceClick() {
    this.trySendInvoice = true;
  }

  isSendInvoiceAvailable() {
    return (
      this.selectedInvoices.length > 0 &&
      this.selectedInvoices.every(
        (i) =>
          i.statusId == InvoiceStatus.Paid || i.statusId == InvoiceStatus.Unpaid
      )
    );
  }

  getSelectedInvoiceIds() {
    return this.selectedInvoices.map((t) => t.invoiceId);
  }

  public onUpdateTable(updated: boolean) {
    this.trySendInvoice = false;
    this.onFilter();
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.pageSize = config.defaultPageSize;
    this.dateFormat = config.dateFormat;
    this.specialDateFormat = this.getSpecialDateFormat(this.dateFormat);
    this.initDropdownArrays();
    this.hasViewAllInvoicesPermission =
      this.userService.currentUser.features.some(
        (f) => f == FeatureEnum.ViewAllInvoices
      );
    this.hasInvoiceMergeUnmergePermission =
      this.userService.currentUser.features.some(
        (f) => f == FeatureEnum.MergeAndUnmergeInvoices
      );
    this.hasEditInvoicePermission = this.userService.currentUser.features.some(
      (f) => f == FeatureEnum.EditInvoice
    );
    this.hasEditInvoiceAccountingPermission =
      this.userService.currentUser.features.some(
        (f) => f == FeatureEnum.ManageInvoiceAccounting
      );
    this.hasInvoiceApprovePermission =
      this.userService.currentUser.features.some(
        (f) => f == FeatureEnum.ApproveInvoice
      );

    this.route.params.subscribe((p) => {
      let invoiceCode = p['code'];
      let customerCredential = p['customer'];
      let invoiceStatus = p['status'];
      if (invoiceCode) {
        this.filterPagingWrapper.filter.invoiceCode = invoiceCode;
      }
      if (customerCredential) {
        this.filterPagingWrapper.filter.customerCredential = customerCredential;
      }
      if (invoiceStatus) {
        this.filterPagingWrapper.filter.invoiceStatus = invoiceStatus;
      }
    });
  }

  initDropdownArrays() {
    this.invoiceStatuses = [
      {
        label: this.translateService.instant('label.Paid'),
        value: InvoiceStatus.Paid,
      },
      {
        label: this.translateService.instant('label.Unpaid'),
        value: InvoiceStatus.Unpaid,
      },
      {
        label: this.translateService.instant('label.Deleted'),
        value: InvoiceStatus.Deleted,
      },
      {
        label: this.translateService.instant('label.Canceled'),
        value: InvoiceStatus.Canceled,
      },
    ];

    this.invoiceAccountingStatuses = [
      { label: '', value: InvoiceAccountingStatus.Empty },
      {
        label: this.translateService.instant('label.Canceled'),
        value: InvoiceAccountingStatus.Canceled,
      },
      {
        label: this.translateService.instant('label.Corrected'),
        value: InvoiceAccountingStatus.Corrected,
      },
      {
        label: this.translateService.instant('label.Sent'),
        value: InvoiceAccountingStatus.Sent,
      },
      {
        label: this.translateService.instant('label.Awaiting'),
        value: InvoiceAccountingStatus.AwaitingCorrection,
      },
    ];

    this.portfolioService.accountManagerList().subscribe((a) => {
      this.accountManagers = a.items;
    });
  }
}
